import { z } from "zod";

export const addRequirementsSchema = z
  .object({
    name: z.string().min(1, "Requirement name is required"),
    type: z.enum(["Inspection", "Community", "Builder"]),
    inspectionAuthorityId: z.string().nullable(),
    communityId: z.string().nullable(),
    accountId: z.string().nullable(),
    materialIds: z.array(z.string()).default([]),
    materialAreas: z.record(z.string(), z.array(z.string())).default({}),
    materialQuantities: z.record(z.string(), z.number().min(1)).default({}),
    steps: z
      .array(
        z.object({
          stepTemplateId: z.string(),
          workBaseTemplateId: z.string(),
        })
      )
      .default([]),
  })
  .superRefine((data, ctx) => {
    if (data.type === "Inspection" && !data.inspectionAuthorityId) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Inspection Authority is required",
        path: ["inspectionAuthorityId"],
      });
    }
    if (data.type === "Community" && !data.communityId) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Community is required",
        path: ["communityId"],
      });
    }
    if (data.type === "Builder" && !data.accountId) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Customer is required",
        path: ["accountId"],
      });
    }
    if (data.materialIds && data.materialIds.length > 0) {
      const missingAreas = data.materialIds.some(
        (id) => !data.materialAreas?.[id] || data.materialAreas[id].length === 0
      );
      if (missingAreas) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          message: "Each item must have at least one area assigned",
          path: ["materialAreas"],
        });
      }
    }
  });

export type IAddRequirementsData = z.infer<typeof addRequirementsSchema> & {
  id?: string;
  modifiedOn?: string;
};
